var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.4 14.6",
    style: {
      enableBackground: "new 0 0 54.4 14.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F58320;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.9,1.8C8.4,1.2,7.8,0.6,7.3,0H0v14.6h7.3c0.6-0.6,1.1-1.2,1.7-1.7C8.9,9.2,8.9,5.5,8.9,1.8z M6.3,11.9H2.7 V2.7h3.6L6.3,11.9L6.3,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1,14.6c0-4.9,0-9.8,0-14.6h7v2.7h-4.3V6h3.8v2.7h-3.8V12h4.3v2.6H10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.1,14.6c0-4.9,0-9.8,0-14.6h3v14.6C20.1,14.6,19.1,14.6,18.1,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.8,0h-2.9l-3.3,14.6c0.9,0,1.8,0,2.6,0c0.3-1.3,0.6-2.6,0.9-3.8h2.3l1,3.8h2.6L35.8,0z M33.6,8.6l0.8-3.1 l0.7,3.1C35.1,8.6,33.6,8.6,33.6,8.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "40.1,14.6 40.1,0 42.8,0 45.2,4.3 45.2,10.8 42.8,7 42.8,14.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "50.3,14.6 50.3,0 47.5,0 45.2,4.3 45.2,10.8 47.6,7 47.6,14.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.2,14.6c0-4.9,0-9.8,0-14.6h3c0,4,0,8,0,12c1.1,0,2.3,0,3.4,0c0,0.9,0,1.7,0,2.6 C26.5,14.6,24.3,14.6,22.2,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.4,14.6c0-4.9,0-9.8,0-14.6h3v14.6C53.4,14.6,52.4,14.6,51.4,14.6z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c8bc6f139d594068b869fb68f173ab2b.svg";
export { ForwardRef as ReactComponent };